import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store';

Vue.use(Router)

let childrenManagement = [
    {
        name: 'logIn',
        path: '/login',
        props: true,
        component: () => import('@/views/CMS/logIn'),
    },
    {
        name: 'Products',
        path: '/products',
        component: () => import('@/views/CMS/products'),
        meta: {
            requiresAuth: true,
        }
    },
    {
        name: 'Orders',
        path: '/orders',
        component: () => import('@/views/CMS/orders'),
        meta: {
            requiresAuth: true,
        }
    }
];
let children = [
    // Dashboard

    {
        name: 'home',
        path: '',
        component: () => import('@/views/home/homePage'),
    },
    {
        name: 'home',
        path: '/home',
        component: () => import('@/views/home/homePage'),
    },
    {
        name: 'Shop',
        path: '/shop',
        component: () => import('@/views/shop'),
    },
    {
        name: 'About Us',
        path: '/aboutUs',
        component: () => import('@/views/aboutUs'),
    },
    {
        name: 'Contact Us',
        path: '/contactUs',
        component: () => import('@/views/contactUs'),
    }, {
        name: 'Purchase',
        path: '/purchase',
        props: true,
        component: () => import('@/views/purchase'),

    }, {
        name: 'Confirm Purchase',
        path: '/confirmPurchase',
        props: true,
        component: () => import('@/views/confirmPurchase'),

    },
    {
        name: 'Terms And Conditions',
        path: '/termsConditions',
        props: true,
        component: () => import('@/views/termsConditions'),
    }
];

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: () => import('@/views/home/index'),
            children: children
        },
        {
            path: '/management',
            component: () => import('@/views/CMS/index'),
            children: childrenManagement
        },
        {
            path: '/**',
            component: () => import('@/views/other/404'),
        }

    ],
})
router.beforeEach((to, from, next) => {

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            next()
            return
        }
        next('/login')
    } else {
        next()
    }
});
router.beforeEach((to, from, next) => {
    next()
});
export default router;
